import { DriverBreaksService } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverBreakEntity } from '../../domain/entities/DriverBreakEntity'
import type { DriverBreakFilterEntity } from '../../domain/entities/DriverBreakFilterEntity'
import type { PostDriverBreakEntity } from '../../domain/entities/PostDriverBreakEntity'
import type { ReviewDriverBreakEntity } from '../../domain/entities/ReviewDriverBreakEntity'
import { DriverBreakRepository } from '../../domain/repositories/DriverBreakRepository'
import { DriverBreakFilterModel } from '../models/DriverBreakFilterModel'
import { DriverBreakModel } from '../models/DriverBreakModel'
import { PostDriverBreakModel } from '../models/PostDriverBreakModel'
import { ReviewDriverBreakModel } from '../models/ReviewDriverBreakModel'

export class DriverBreakRepositoryImpl implements DriverBreakRepository {
  async getDriverBreak(id: string): Promise<DriverBreakEntity | { error: true }> {
    try {
      const response = await DriverBreaksService.getDriverBreakAdmin({ id })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }

  async getDriverBreaks(
    filterData: DriverBreakFilterEntity
  ): Promise<PaginateEntity<DriverBreakEntity[]> | { error: true }> {
    const driverBreakFilterModel = new DriverBreakFilterModel(filterData)

    try {
      const response = await DriverBreaksService.getDriverBreaksAdmin(driverBreakFilterModel)
      const driverBreakModels = response.items?.map((item) => new DriverBreakModel(item))
      return new PaginateEntity<DriverBreakEntity[]>(response, driverBreakModels)
    } catch {
      return { error: true }
    }
  }

  async createDriverBreak(data: PostDriverBreakEntity): Promise<DriverBreakEntity | { error: true }> {
    const requestModel = new PostDriverBreakModel(data)

    try {
      const response = await DriverBreaksService.postDriverBreakAdmin({
        requestBody: requestModel
      })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }

  async approveDriverBreak(
    id: string,
    data: ReviewDriverBreakEntity
  ): Promise<DriverBreakEntity | { error: true }> {
    const requestModel = new ReviewDriverBreakModel(data)

    try {
      const response = await DriverBreaksService.postApproveDriverBreakAdmin({
        id,
        requestBody: requestModel
      })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }

  async rejectDriverBreak(
    id: string,
    data: ReviewDriverBreakEntity
  ): Promise<DriverBreakEntity | { error: true }> {
    const requestModel = new ReviewDriverBreakModel(data)

    try {
      const response = await DriverBreaksService.postRejectDriverBreakAdmin({
        id,
        requestBody: requestModel
      })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }

  async completeDriverBreak(id: string): Promise<DriverBreakEntity | { error: true }> {
    try {
      const response = await DriverBreaksService.postCompleteDriverBreakAdmin({ id })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }

  async cancelDriverBreak(id: string): Promise<DriverBreakEntity | { error: true }> {
    try {
      const response = await DriverBreaksService.postCancelDriverBreakAdmin({ id })
      return new DriverBreakModel(response)
    } catch {
      return { error: true }
    }
  }
}
